export enum GlobalApiQueryKeys {
  SitemateStartAccount = 'sitemate-start-account',
}
